/**
 * @file 剪贴板相关操作
 */
import copy from 'copy-to-clipboard';
/**
 * 复制内容到剪贴板
 *
 * @category Clipboard
 * @param text - string 需要被复制的内容
 * @returns 是否成功复制到剪贴板 boolean
 */
export const copyToClipboard = (text) => copy(text);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xpcGJvYXJkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2Z1bmN0aW9ucy9jbGlwYm9hcmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxPQUFPLElBQUksTUFBTSxtQkFBbUIsQ0FBQTtBQUVwQzs7Ozs7O0dBTUc7QUFDSCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsQ0FBQyxJQUFZLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQSJ9